import { FC, useMemo } from 'react';

import { PERSONA_NFT_STORAGE } from '@web/features/const';
import { SharpLoaderImage } from '@web/utils/sharp-loader';

import { ISharpImageProps, SharpImage } from './SharpImage';

const SIZES = [
  50, 80, 100, 120, 160, 200, 240, 340, 400, 680, 800, 1200, 1400, 1600, 2400,
  4096,
];

function buildSrc(tokenId: string): SharpLoaderImage[] {
  return [
    {
      name: 'blur.png',
      width: 1,
      height: 1,
      url: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXu59XjgIMAAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==',
      format: 'png',
      type: 'image/png',
    },
    ...SIZES.map(
      (size) =>
        ({
          name: `${size}.webp`,
          width: size,
          height: size,
          url: `${PERSONA_NFT_STORAGE}/${tokenId}/${size}.webp`,
          format: 'webp',
          type: 'image/webp',
        }) as const,
    ),
    ...SIZES.map(
      (size) =>
        ({
          name: `${size}.jpeg`,
          width: size,
          height: size,
          url: `${PERSONA_NFT_STORAGE}/${tokenId}/${size}.jpeg`,
          format: 'jpeg',
          type: 'image/jpg',
        }) as const,
    ),
  ];
}

interface IProps extends Omit<ISharpImageProps, 'src'> {
  tokenId: bigint | string | number;
}

export const SharpPersonaImage: FC<IProps> = ({ tokenId, alt, ...props }) => {
  const src = useMemo(() => buildSrc(String(tokenId)), [tokenId]);

  return (
    <SharpImage
      src={src}
      alt={alt === undefined ? `Persona #${tokenId}` : alt}
      {...props}
    />
  );
};
